import { gql } from '@apollo/client';

const schema = {
  create: {
    name: 'createProductShop',
    serviceName: 'shopadmin',
    query: gql`
      mutation createProductShop(
        $product_id: String!
        $shop_id: String!
        $booth_id: String!
        $co_price: String
        $me_price: String
        $unit_fie_id: String
        $stock: String
        $max_number_buy: String
        $nonexistent_number: String
        $is_active: Int
        $details: String
      ) {
        createProductShop(
          product_id: $product_id
          shop_id: $shop_id
          booth_id: $booth_id
          co_price: $co_price
          me_price: $me_price
          unit_fie_id: $unit_fie_id
          stock: $stock
          max_number_buy: $max_number_buy
          nonexistent_number: $nonexistent_number
          is_active: $is_active
          details: $details
        ) {
          messages
        }
      }
    `,
  },
};

export default schema;
